import { render, staticRenderFns } from "./PopupMain.vue?vue&type=template&id=b479e218&scoped=true"
import script from "./PopupMain.vue?vue&type=script&lang=js"
export * from "./PopupMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b479e218",
  null
  
)

export default component.exports